export const turnover = (deg) => deg + 360;
export const plusAnswer = (answers) => answers + 1;
export const minusAnswer = (answers) => answers - 1;
export const getRandom = () => Math.random();
